export const CarouseInfiniteScrollerMixin = (Base) => class extends Base {
  static values = {
    ...Base.values,
    infiniteScroll: { type: Boolean, default: true }
  }

  connect() {
    if (this.infiniteScrollValue === false) {
      return super.connect()
    }

    this.#cloneFirstAndLastItems()
    super.connect()
  }

  disconnect() {
    if (this.infiniteScrollValue === false) {
      return super.disconnect()
    }

    this.clonedItemsIntersectionObserver.disconnect()
    clearTimeout(this.clonedItemsScrollTimeout)
    super.disconnect()
  }

  _scrollOffsetWidth(index) {
    if (this.infiniteScrollValue === false) {
      return super._scrollOffsetWidth(index)
    }

    return super._scrollOffsetWidth(index) + this.wrapperTarget.offsetWidth
  }

  #cloneFirstAndLastItems() {
    this.clonedItems = [
      this.itemTargets
        .at(0).cloneNode(true),
      this.itemTargets.at(-1).cloneNode(true)
    ]
    this.clonedItems.forEach(item => item.setAttribute(`data-${this.identifier}-target`, "cloned-item"))

    this.wrapperTarget.append(this.clonedItems.at(0))
    this.wrapperTarget.prepend(this.clonedItems.at(-1))

    this.clonedItemsIntersectionObserver = new IntersectionObserver(
      this.#handleClonedItemsIntersectionObserver.bind(this),
      {
        root: this.wrapperTarget,
        rootMargin: "1px", // a small margin is needed so the intersection works on carousels with subpixel widths. Ex.: 401.23px, 709.18px, etc
        threshold: 1.0,
      }
    )
    this.clonedItems.forEach(item => this.clonedItemsIntersectionObserver.observe(item))
  }

  #handleClonedItemsIntersectionObserver(entries) {
    entries.forEach((entry) => {
      const elem = entry.target

      if (entry.isIntersecting) {
        clearTimeout(this.clonedItemsScrollTimeout)

        if (elem === this.clonedItems.at(0)) {
          this.clonedItemsScrollTimeout = setTimeout(() => {
            this._scrollToItem(0, { behavior: "instant" })
          }, 100)
        }
        if (elem === this.clonedItems.at(-1)) {
          this.clonedItemsScrollTimeout = setTimeout(() => {
            this._scrollToItem(this.itemTargets.length - 1, { behavior: "instant" })
          }, 100)
        }
      }
    })
  }
}
